import React, { useRef, useMemo } from 'react';
import { I18n } from 'js/components/common/I18n';
import { useComponentTranslations } from 'js/hooks/component';

export const useFieldLabel = (label: string) => {
    const labelRef = useRef<HTMLSpanElement>(null);
    const componentTranslate = useComponentTranslations();

    return useMemo((): [JSX.Element | null, () => string] => {
        if (!label) {
            return [null, () => ''];
        }

        return [
            <I18n
                tKey={label}
                ref={labelRef}
                defaultValue={label}
                t={componentTranslate}
            />,
            () => labelRef.current?.innerText || ''
        ];
    }, [label, componentTranslate]);
};
